import React, { FC, useMemo } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { getProtectedImageUriFromString } from '../../utils/FileAccessUtils';

export const BRAND_DISPLAY_TYPE = {
	WO_CREATION: 'WO_CREATION',
	WO_PRINTABLE: 'WO_PRINTABLE',
	LOCATION_CARD: 'LOCATION_CARD',
};

const BrandLogoDisplay: FC<any> = ({
	brand,
	userType,
	displayType,
	onLoad = () => {},
}): React.ReactElement => {
	const logoUrl = useMemo(
		() =>
			nullSafeGet('logoAttachment.fileId', brand)
				? getProtectedImageUriFromString(userType)(
						`${brand.logoAttachment.fileId}/${brand.logoAttachment.fileName}`,
						600,
						600
				  )
				: '',
		[brand, userType]
	);

	const { containerClassName, imgClassName } = useMemo(() => {
		switch (displayType) {
			case BRAND_DISPLAY_TYPE.WO_CREATION:
				return {
					containerClassName:
						'mr-2 flex h-8 w-8 shrink-0 items-center justify-center lg:mb-2 lg:mr-0 lg:h-16 lg:w-16',
					imgClassName: 'max-h-full max-w-full object-contain',
				};
			case BRAND_DISPLAY_TYPE.LOCATION_CARD:
				return {
					containerClassName: 'mb-1 flex h-12 w-16 shrink-0 items-center',
					imgClassName: 'max-h-full max-w-full object-contain',
				};
			case BRAND_DISPLAY_TYPE.WO_PRINTABLE:
				return {
					containerClassName: 'mr-3 flex h-10 w-14 shrink-0 items-center',
					imgClassName: 'max-h-full max-w-full object-contain',
				};
			default:
				return {
					containerClassName: 'mr-3 flex h-10 w-10 shrink-0 items-center justify-center',
					imgClassName: 'max-h-full max-w-full object-contain',
				};
		}
	}, [displayType]);

	return logoUrl ? (
		<div className={containerClassName}>
			<img
				src={logoUrl}
				alt={nullSafeGet('brandName', brand)}
				className={imgClassName}
				onLoad={onLoad}
			/>
		</div>
	) : null;
};

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(BrandLogoDisplay);
